/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { layers } from '@atlaskit/theme';

export const Wrapper = styled.div<{
  topOffset: number;
}>(({ topOffset }) => ({
  position: 'fixed',
  top: `${topOffset}px`,
  width: '100%',
  /* Site banner is given z-index one more than that of Sidebar to make it appear on top. */
  zIndex: layers.blanket() + 1,
}));

export const DismissButton = styled(Button)({
  '&, &:hover, &:focus': {
    position: 'absolute',
    top: '50%',
    right: '1%',
    transform: 'translateY(-50%)',
  },
});
